import Button from "devextreme-react/button";
import { useContext } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useUpdateWorkOrder } from "../api/update-work-order";
import { WorkOrderContext } from "../context/WorkOrderContext";
import { WorkOrderProgressStep } from "../types/WorkOrderProgressStep";
import { WorkOrderUpdateType } from "../types/UpdateWorkOrderParams";
import { LoadPagePanel } from "../../../../components";

export default function SaveButton(params: { step: WorkOrderProgressStep }) {

	const navigate = useNavigate();
	const location = useLocation();

	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");

	const { order, refetchOrder } = useContext(WorkOrderContext);

	let updateType: WorkOrderUpdateType;

	switch (params.step) {
		case WorkOrderProgressStep.Contact:
			updateType = WorkOrderUpdateType.CustomerContact;
			break;

		case WorkOrderProgressStep.Schedule:
			updateType = WorkOrderUpdateType.Schedule;
			break;

		case WorkOrderProgressStep.Complete:
			updateType = WorkOrderUpdateType.Complete;
			break;
	}

	const updateWorkOrder = useUpdateWorkOrder(
		{ wo: order.details, updateType: updateType! },
		(result) => {
			showSuccessMessage('Work order has been updated');
			refetchOrder()
				.then(() => {
					if (params.step !== WorkOrderProgressStep.Info) {
						const newActionRequiredID = result.activeARs[0];

						const to = `/cfi/work-order/${order.details.workOrderID}/${newActionRequiredID}` +
							(!!returnUrl ? '?returnUrl=' + returnUrl : '');

						if (newActionRequiredID && newActionRequiredID !== 490 && location.pathname !== to) {
							navigate(to);
						}
					}
				})
		},
		(error) => showErrorMessage(error)
	);

	return (
		<>
			<Button
				text="Save Changes"
				icon="Inscyth-Save"
				disabled={!order.modified || updateWorkOrder.isLoading}
				onClick={(e) => {
					let result = e.validationGroup.validate();
					if (result.isValid) {
						updateWorkOrder.mutate();
					}
				}} >
			</Button>
			<LoadPagePanel visible={updateWorkOrder.isLoading} />
		</>
	)
}
